import { createContext} from "react";


export const themeContext = createContext();
export const userInfoContext = createContext();
export const currentpageContext = createContext();



export const topicfilterContext = createContext();
export const activitytypefilterContext = createContext();
export const topiclistContext = createContext();
export const modulelistContext = createContext();

export const currentActivityContext = createContext();
export const sourceMaterialContext = createContext();

export const myClasesContext = createContext();
export const currentclassContext = createContext();
export const personlistContext = createContext();
export const myArchivedContext = createContext();


export const departmentsContext = createContext();
export const currentdeptContext = createContext();


export const announcementlistContext = createContext();
export const classAndstudentselectionContext = createContext();

export const forcerefreshContext = createContext();
export const currentdepartment = createContext();
export const settingsContext = createContext();
export const deptInfoContext = createContext();


export const subjectfilterContext = createContext();
export const subjectlistContext = createContext();
export const adminclasslistContext = createContext();
export const accountlistContext = createContext();
export const adminYearfilterContext = createContext();
export const adminSampleClassContext = createContext();
export const admintopicsourceContext= createContext();
export const subjectmoduleContext = createContext();
export const classbannerContext = createContext();
export const updatelistContext = createContext();

export const responseContext = createContext();


export const forceviewContext= createContext();

export const setactivityContext = createContext();